module.exports = __webpack_public_path__ + "img/light-show.7ed26c9.svg";